import React, { useEffect, useRef, useState } from "react";
import styles from "./stat-collection.module.css";
import Decimal from "decimal.js";
import { getUIText } from "../../translation";

export default function StatCollection({ lang, result }) {
    const ref = useRef(null);
    // const [isWide, setIsWide] = useState();

    useEffect(() => {
        const className = styles["scrolled"];
        const handleScroll = () => {
            if (!ref.current) return;
            if (window.scrollY > 0) {
                ref.current.classList.add(className);
            } else {
                ref.current.classList.remove(className);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // useEffect(() => {
    //     const calcWrapperWidth = () => {
    //         let isWide = false;
    //         if (ref.current === null) {
    //             isWide = window.innerWidth < 1200;
    //         } else {
    //             isWide = ref.current.offsetWidth > 190;
    //         }

    //         setIsWide(isWide);
    //     };

    //     calcWrapperWidth();

    //     window.addEventListener("resize", calcWrapperWidth);

    //     return () => {
    //         window.removeEventListener("resize", calcWrapperWidth);
    //     };
    // }, []);

    return (
        <div className={styles["savior-stat-collection-container"]} ref={ref}>
            <div className={styles["title"]}>{getUIText(lang, "simulator.title.total.status")}</div>
            <div className={styles["battle-powers"]}>
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.combatPower")}</span>
                    <span className={styles["value"]}>{result.battle_power.toLocaleString("ko-KR")}</span>
                </div>
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.combatPowerDefense")}</span>
                    <span className={styles["value"]}>{result.battle_power_defense.toLocaleString("ko-KR")}</span>
                </div>
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.combatPowerBalance")}</span>
                    <span className={styles["value"]}>{result.battle_power_balance.toLocaleString("ko-KR")}</span>
                </div>
            </div>
            {/* {isWide && ( */}
            <table>
                <tbody>
                    <tr>
                        <td>{getUIText(lang, "simulator.total.atk")}</td>
                        <td>{getUIText(lang, "simulator.total.hp")}</td>
                        <td>{getUIText(lang, "simulator.total.def")}</td>
                        <td>{getUIText(lang, "simulator.total.spd")}</td>
                        <td>{getUIText(lang, "simulator.total.critRate")}</td>
                        <td>{getUIText(lang, "simulator.total.critDmg")}</td>
                        <td>{getUIText(lang, "simulator.total.effRate")}</td>
                        <td>{getUIText(lang, "simulator.total.effResist")}</td>
                    </tr>
                    <tr>
                        <td>{result.atk.toLocaleString("ko-KR")}</td>
                        <td>{result.hp.toLocaleString("ko-KR")}</td>
                        <td>{result.def.toLocaleString("ko-KR")}</td>
                        <td>{result.spd}</td>
                        <td>{new Decimal(result.crit_rate).div(100).toNumber().toLocaleString("ko-KR")}%</td>
                        <td>{new Decimal(result.crit_dmg).div(100).toNumber().toLocaleString("ko-KR")}%</td>
                        <td>{new Decimal(result.eff_rate).div(100).toNumber().toLocaleString("ko-KR")}%</td>
                        <td>{new Decimal(result.eff_resist).div(100).toNumber().toLocaleString("ko-KR")}%</td>
                    </tr>
                </tbody>
            </table>
            {/* )} */}
            {/* {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.atk")}</span>
                    <span className={styles["value"]}>{result.atk.toLocaleString("ko-KR")}</span>
                </div>
            )}
            {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.hp")}</span>
                    <span className={styles["value"]}>{result.hp.toLocaleString("ko-KR")}</span>
                </div>
            )}
            {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.def")}</span>
                    <span className={styles["value"]}>{result.def.toLocaleString("ko-KR")}</span>
                </div>
            )}
            {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.spd")}</span>
                    <span className={styles["value"]}>{result.spd}</span>
                </div>
            )}
            {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.critRate")}</span>
                    <span className={styles["value"]}>{new Decimal(result.crit_rate).div(100).toNumber().toLocaleString("ko-KR")}%</span>
                </div>
            )}
            {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.critDmg")}</span>
                    <span className={styles["value"]}>{new Decimal(result.crit_dmg).div(100).toNumber().toLocaleString("ko-KR")}%</span>
                </div>
            )}
            {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.effRate")}</span>
                    <span className={styles["value"]}>{new Decimal(result.eff_rate).div(100).toNumber().toLocaleString("ko-KR")}%</span>
                </div>
            )}
            {!isWide && (
                <div className={styles["stat"]}>
                    <span className={styles["type"]}>{getUIText(lang, "simulator.total.effResist")}</span>
                    <span className={styles["value"]}>{new Decimal(result.eff_resist).div(100).toNumber().toLocaleString("ko-KR")}%</span>
                </div>
            )} */}
        </div>
    );
}
